import { action, observable } from 'mobx'

import Ds from './ds'

class PaymentIntervals {
  @observable data = [{
    id: 0,
    name: 'Loading...'
  }]

  @observable ds = new Ds()

  @action loadAllPaymentIntervals() {
    this.ds.query(`{ paymentIntervals(hash: "${ localStorage.getItem('userHash') }") { id name } }`, (response) => {
      if (response.paymentIntervals.length > 0) {
        this.data = response.paymentIntervals
      }
    })
  }

  @action newPaymentInterval(name) {
    this.ds.query(`mutation { addPaymentInterval(name: "${ name }", hash: "${ localStorage.getItem('userHash') }") { id } }`, (data) => {
      this.loadAllPaymentIntervals()
    })
  }

  @action updatePaymentInterval(id, name) {
    this.ds.query(`mutation { updatePaymentInterval(id: ${ id }, name: "${ name }", hash: "${ localStorage.getItem('userHash') }") { id } }`, (data) => {
      this.loadAllPaymentIntervals()
    })
  }

  @action deletePaymentInterval(id) {
    this.ds.query(`mutation { deletePaymentInterval(id: ${ id }, hash: "${ localStorage.getItem('userHash') }") { id } }`, (data) => {
      this.loadAllPaymentIntervals()
    })
  }
}

export default new PaymentIntervals



// WEBPACK FOOTER //
// ./src/stores/paymentintervals.js